import FooterLinksSection from "./FooterLinksSection";
import FooterLogoSection from "./FooterLogoSection";
import FooterQRCodeSection from "./FooterQRCodeSection";

const Footer = () => {
  return (
    <footer className="lg:h-157.5 flex items-center flex-col justify-center bg-black">
      <div className="container flex items-start justify-between py-10 lg:py-23.5 lg:flex-row flex-col">
        <FooterLogoSection />
        <FooterLinksSection />
        <FooterQRCodeSection />
      </div>

      <div className="container mt-auto h-18 border-t border-white/10 flex items-center justify-center">
        <p className="text-xs lg:text-sm text-white">
          © Copyright <strong>Dalal 2026</strong> All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
